import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class IpAddressService {
  private api = inject(ApiService);

  list(scope: string | 'all' = 'all') {
    const path = scope === 'all' ? '/address' : `/address/${scope}`;
    return this.api.get(path);
  }
  upsert(json: any) { return this.api.post('/address', json); }
  remove(id: number) { return this.api.get(`/address/remove/${id}`); }
}
